import { useDimensions } from "@repo/core/hooks/useDimensions";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { useSearchParams } from "@repo/core/hooks/useSearchParams";
import { ROUTES } from "@repo/core/routes";
import { ProposalTypeEnum } from "@repo/core/screens/ProposalEffectiveFlows/Credit/DetailsCreditProposal/consts";
import { useMemo, useState } from "react";

export const DetailsCreditProposalController = () => {
  const { isMobile } = useDimensions();
  const { replace, back } = useNavigation();
  const [isLoading] = useState(false);

  const params = useSearchParams();

  const proposalId = params?.id;

  // TODO: remove only for mock
  const proposalType = useMemo(() => {
    const isValidProposalType = Object.values(ProposalTypeEnum).includes(
      proposalId as ProposalTypeEnum
    );
    return isValidProposalType
      ? (proposalId as ProposalTypeEnum)
      : ProposalTypeEnum.CREDIT;
  }, [proposalId]);

  const handleGoBack = () => {
    back();
  };

  const handleClose = () => {
    replace(ROUTES.home);
  };

  return {
    isMobile,
    proposalType,
    handleGoBack,
    handleClose,
    isLoading
  };
};
